<script setup>
import { computed, ref } from 'vue';
import ILink from '@components/ILink/ILink.vue';
import EventItemsSkeleton from '@components/EventItemsSkeleton.vue';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import useCartStore from '@vueApp/store/modules/cart.js';
import CartItem from './components/CartItem.vue';

translator.getLanguages();

const cartStore = useCartStore();

const orders = computed(() => cartStore.getCart.value);
const loadingCart = ref(true);
cartStore.loadCart().finally(() => (loadingCart.value = false));
</script>

<template>
  <div class="lk">
    <div class="lk__top">
      <h1 class="lk__title">{{ translator.t("main", "Cart") }}</h1>
      <ILink
        v-if="orders.length"
        :icon-name="'close'"
        class="button close-btn lk__close-btn"
        @click="cartStore.clearCart"
      >
        <span>{{ translator.t('main', 'Clear') }}</span>
      </ILink>
    </div>
    <EventItemsSkeleton v-model="loadingCart">
      <div v-if="orders.length" class="order">
        <CartItem v-for="order in orders" :key="order.id" :order="order" />
      </div>

      <div v-if="!orders.length" class="lk__empty">
        <div class="lk__small-title">{{ translator.t('main', 'The cart is empty') }}</div>
        <p>{{ translator.t('main', 'Your cart is empty. Let\'s buy a ticket to the match!') }}</p>
        <a href="/" class="lk__button btn reset-btn">{{ translator.t('main', 'Go to tickets') }}</a>
      </div>
    </EventItemsSkeleton>
  </div>
</template>
